<template>
	<router-view></router-view>
</template>

<script setup lang="ts">
import { isMiniProgram } from '@/utils/utils'
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { device } from "wnl-xdsdk"

const router = useRouter()
const route = useRoute()

onMounted(async () => {
	// 等待路由准备就绪
	await router.isReady()

	if (isMiniProgram || (window.location && window.location.href.includes('tclx'))) {
		// console.log('小程序index')
	} else {
		const queryParams = { ...route.query }
		console.log('queryParams:', queryParams)

		if (device.isAndroid || device.isIos || device.isHarmony) {
			router.replace({
				path: "/m",
				query: queryParams
			})
		} else {
			router.replace({
				path: "/",
				query: queryParams
			})
		}
	}
})
</script>

<style scoped lang="scss">
@font-face {
	font-family: HYRY;
	src: url(#{$font}/source.ttf);
}

.pace .pace-progress {
	background: #6275CE;
}
</style>